// extracted by mini-css-extract-plugin
export var button = "_kf-0";
export var donut = "_kf-1";
export var donutFill = "_kf-3";
export var donutTrack = "_kf-2";